module.exports = __webpack_public_path__ + "img/2.c4bdaca6.png";